document.addEventListener('alpine:init', () => {
  Alpine.data('xAnnouncementBars', (bar) => ({
    init() {
      const content = bar.settings.content;
      if (!/{count_down}/i.test(content)) return; // Text kommt schon aus Liquid

      this.$el.innerHTML = content.replace(
        /{count_down}/gi,
        `<span class="x-countdown-${bar.id} bar-countdown inline-block width-countdown"></span>`
      );
      const els = [...this.$el.querySelectorAll(`.x-countdown-${bar.id}`)];

      Alpine.store('xHelper').countdown(bar.settings, (canShow, s, m, h, d) => {
        if (!canShow) {
          els.forEach(el => el.remove());
          return;
        }
        const days = d > 0 ? `${d}D  ` : '';
        const hours = h == 0 && !days ? '' : `${h} : `;
        const text = `${days}${hours}${m} : ${s}`;
        els.forEach(el => { if (el.textContent !== text) el.textContent = text; });
      });
    }
  }));
});